var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.spinner),expression:"$store.state.spinner"}],staticClass:"loader"},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }